// extracted by mini-css-extract-plugin
module.exports = {"box":"ResourceRequestsViewParentRows_box__2OwEI","status":"ResourceRequestsViewParentRows_status__3wxk5","reject":"ResourceRequestsViewParentRows_reject__3gG0v"};